import React from 'react';
import './date-scroll.css'

interface MyProps {
    datesConfig: any,
    notify
}
interface MyState{
    dates: any;
    selectedDate: any,
    displayDate: any

}
export class DateScroll extends React.Component<MyProps,MyState> {

//   @Input('datesConfig') datesConfigJSON: any;

    state:MyState = {
        dates:[],
        selectedDate:null,
        displayDate:null
    }
  
  onClick(dt:any) {
    console.log("Selected Date : "+this.getStringDate(dt.dateObject));
    this.setSeletedDate(dt.dateObject);
    this.props.notify(dt);
  }

  constructor(props) {
    super(props)
    this.initDatePicker();    
  }

  initDatePicker() {    
    setTimeout(() => { 
    console.log(this.props.datesConfig)
      this.setState({selectedDate : this.props.datesConfig.defaultSeletedDate});
      this.state.selectedDate = this.props.datesConfig.defaultSeletedDate
      var daysShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      var _seletedDate = this.state.selectedDate;
      this.setState({displayDate : this.getDisplayDate(this.state.selectedDate)});
      var getDateArray = function(start, end) {        
          var arr = new Array();
          var dt = new Date(start);
          while (dt <= end) {
            var selected = false;
            if((_seletedDate.getDate()==dt.getDate()) && (_seletedDate.getMonth()==dt.getMonth())) {
              selected = true;
            }
            //arr.push({dateObject:new Date(dt), date:dt.getDate(), month:months[dt.getMonth()], year:dt.getFullYear(), day:days[dt.getDay()], shortDay:daysShort[dt.getDay()], stringDate:stringDate, selected:selected});
            arr.push({dateObject:new Date(dt), date:dt.getDate(), shortDay:daysShort[dt.getDay()], selected:selected});
            dt.setDate(dt.getDate() + 1);
          }
          return arr;
      }

      this.setState({dates : getDateArray(this.props.datesConfig.startDate, this.props.datesConfig.endDate)});
    }, 500);
  }

  setSeletedDate(dt:any) {
    for(var i=0; i<this.state.dates.length; i++) {
      var selected = false;
      if((dt.getDate()==this.state.dates[i].dateObject.getDate()) && (dt.getMonth()==this.state.dates[i].dateObject.getMonth())) {
        selected = true;
        this.setState({selectedDate : this.state.dates[i].dateObject});
        console.log(this.state.dates[i].dateObject);
        console.log("selected date in setSelectedDate")
        this.setState({displayDate : this.getDisplayDate(this.state.dates[i].dateObject)});
      }
      this.state.dates[i].selected=selected;
    }
  }

  getStringDate(dateObject: any) {
    var dt = new Date(dateObject);
    var dd: any = dt.getDate();
    var mm: any = dt.getMonth()+1;
    var yyyy = dt.getFullYear();
    if(dd<10){dd='0'+dd} if(mm<10){mm='0'+mm}
    return dd+'/'+mm+'/'+yyyy;
  }

  getDisplayDate(dt: any) {
      console.log(dt)
    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return days[dt?.getDay()]+", "+dt?.getDate()+" "+months[dt?.getMonth()]+" "+dt?.getFullYear();
  }

  logScrollEnd() {
    console.log("Scroll End");
  }

  logScrollStart() {
    console.log("Scroll Start");  
  }

  logScrolling() {
    console.log("Scrolling");  
  }

  render() {
      return(
          <div className="date-scroll">
        <div className="container-fluid">
            <div className="scrolling-wrapper row flex-row flex-nowrap">
                {this.state.dates.map((date,i) => (
                     
                    <div className="card" onClick={() => this.onClick(date)}>
                        <div className="card-head">{date.shortDay}</div>
                        <div className="card-body">
                            {date.selected==true ?  <div className="text-center date-active">{date.date}</div> : <div className="one-line-text text-center">{date.date}</div>} 
                        </div>
                    
                    </div>
                ))}
                </div>
                </div>
      <div className="date-label">{this.state.displayDate}</div>
      </div>
      )
  }

}
